import { Box, Typography, useTheme } from "@mui/material";
import LogoKarenSVG from "../../../../../media/images/logos/KarenTarabarNet-App.png";
import WalletEmpty from "../../../../../media/images/icons/empty-wallet";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../../hooks/useRedux";
import { addCommas } from "@persian-tools/persian-tools";

export default function DashboardHeader() {
  const navigate = useNavigate();

  const { stock } = useAppSelector((state) => state.owner);

  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        // border: "1px solid gray",
      }}
    >
      <Box
        sx={{
          backgroundColor: "bgColor.white",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "4px",
          borderRadius: "12px",
        }}
      >
        <img width={170} src={LogoKarenSVG} alt="" />
      </Box>
      <Box
        onClick={() => navigate("../wallet")}
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: theme.palette.bgColor.blueGrey50,

          padding: "4px",
          borderRadius: "10px",
          gap: "4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "bgColor.white",
            height: "100%",
            padding: "4px",
            borderRadius: "8px",
            gap: "4px",
          }}
        >
          <WalletEmpty color={theme.palette.textColor.main} />
          <Typography
            sx={{
              fontSize: "16px",
            }}
          >
            {addCommas(stock || "0")} ریال
          </Typography>
        </Box>
        {/* <NotifSingleButton path="../notifs" /> */}
      </Box>
    </Box>
  );
}
